// extracted by mini-css-extract-plugin
export var cardTitle = "timeline-event-card-module--card-title--hYbB6";
export var description = "timeline-event-card-module--description--l8m1E";
export var eventCard = "timeline-event-card-module--event-card--NJDy8";
export var eventCardImage = "timeline-event-card-module--event-card-image--ZDlHp";
export var eventCardVideo = "timeline-event-card-module--event-card-video--mgPXZ";
export var innerContainer = "timeline-event-card-module--innerContainer--J2uO5";
export var mobileWidth = "767px";
export var scrollContainer = "timeline-event-card-module--scrollContainer--rZJof";
export var textAndScroll = "timeline-event-card-module--textAndScroll--fPJjC";